import { useContext } from "react"
import PageContext from "../components/page-context"
import { t } from "../i18n-utility"

export const useTranslations = () => {
  const { translations } = useContext(PageContext)

  return t.bind(null, translations)
}
